import React from "react";
import { useState, useContext } from "react";
import { Link } from 'react-router-dom';

import SearchBar from "./common/SearchBar";
import Loader from './common/Loader';

import axios_api from "../Api";
import { API_URL, AUTH_TOKEN } from '../Context';


// Функция для форматирования размера файла
function formatFileSize(bytes) {
  if (!bytes || bytes === 0) return '-';
  
  const kb = bytes / 1024;
  const mb = kb / 1024;
  
  if (mb >= 1) {
    return `${mb.toFixed(2)} МБ`;
  } else if (kb >= 1) {
    return `${kb.toFixed(2)} КБ`;
  } else {
    return `${bytes} байт`;
  }
}


function Asset({asset}){

  return(
    <tr className="">
      <td>
        {asset.type === 'FILE' && 
          <span className="form-asset form-asset-file text-center mx-1 px-2">{asset.type.toLowerCase() }</span>
        }
        {asset.type === 'LINK' && 
          <span className="form-asset form-asset-link text-center mx-1 px-2">{asset.type.toLowerCase() }</span>
        }
      </td>
      <td><Link className="" to={`/asset/` + asset.id}> {asset.name}</Link></td>
      <td>{asset.category?.name}</td>
      <td>
          <a 
            href={asset.file || asset.link} 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-truncate d-inline-block text-decoration-none"
            style={{maxWidth: '300px'}}
          >
            {asset.file || asset.link}
          </a>
      </td>        
      <td>{formatFileSize(asset.file_size)}</td>
      <td>{asset.date_created}</td>
      <td>{asset.date_modified} </td>
      <td>
        {asset.form && asset.form.length > 0 ? (
          <div>
            {asset.form.map((form, index) => (
              <div key={form.id || index}>
                <Link to={`/form_builder/${form.id}`} target="_blank" rel="noopener noreferrer">{form.form_code}</Link>
              </div>
            ))}
          </div>
        ) : (
          '-'
        )}
      </td>
    </tr>
  )
}

function YearAssets ({year}) {

  const [loading, setLoading] = useState(true);
  const [assets, setAssets] = useState([]);
  const [searchText, setSearchText] = useState('');
  const api_url = useContext(API_URL);  
  const token = useContext(AUTH_TOKEN);

  React.useEffect(() => {
    let assets = axios_api.get(api_url + '/assets/', {
      headers: {"Authorization": token},
      params: {"year": year}
    });

    assets.then(
      (result) => {
        let apiReturnedAssets = result.data;
        setAssets(apiReturnedAssets);
        setLoading(false);
      },
      (error) => {
        console.log(error)
        setAssets([]);
      }
    );
  }, []);


  let rows = [];
  for(let i in assets) {
    if (
      assets[i].name.toLowerCase().indexOf(searchText.toLowerCase()) === -1 
    ) {
      //pass
    } else {
      rows.push(
        <Asset
          key={assets[i].id}
          asset={assets[i]}  
        />
      );
    }
  }  

  return ( loading ? 
    (
      <Loader/>
    ) : (  
      <div className="ms-5">
        <div className="m-3">
          <SearchBar
            key="SearchBar" 
            searchText={searchText} 
            onSearchtextChange={setSearchText} 
          />
        </div>
        <div className="row m-3">
          <table className="table">
            <thead>
              <tr> 
                <th className="ps-3">тип</th>
                <th>имя</th>
                <th>категория</th>
                <th>материал</th>
                <th>размер</th>
                <th>создан</th>         
                <th>обновлен</th>
                <th>связанные формы</th>
              </tr>
            </thead>
            <tbody>
              {rows} 
            </tbody>
          </table>
        </div>
      </div>
    ) 
  )   
}


export default function AssetList () {

  const [assetsYears, setAssetsYears] = useState([])

  const api_url = useContext(API_URL);  
  const token = useContext(AUTH_TOKEN);


  React.useEffect(() => {
    let assetsYears = axios_api.get(api_url + '/assets_years/', {
      headers: {"Authorization": token},
    });

    assetsYears.then(
      (result) => {
        let apiReturnedAssetsYears = result.data;
        setAssetsYears(apiReturnedAssetsYears);
      },
      (error) => {
        console.log(error)
        setAssetsYears([]);
      }
    );

  }, []);

  function openYearFolder (i) {
    let newAssetsYears = structuredClone(assetsYears);
    newAssetsYears[i].selected = true;
    setAssetsYears(newAssetsYears)
  }

  function closeYearFolder (i) {
    let newAssetsYears = structuredClone(assetsYears);
    newAssetsYears[i].selected = false;
    setAssetsYears(newAssetsYears)
  }

  let assetsYearsRows = []
  for(let i in assetsYears) {
    if (assetsYears[i].selected === true) {
      assetsYearsRows.push(
        // Without the `key`, React will fire a key warning. 
        // <React.Fragment></React.Fragment> - из full syntax for <></> shortcut
        <React.Fragment 
          key={assetsYears[i].year}
        >
          <div
            className="row mx-3 mt-3 p-2 pt-3 rounded year-hover"
            onClick={() => closeYearFolder(i)}
          >
            <h3>
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" className="bi bi-folder-minus me-3" viewBox="0 0 16 16">
                <path d="m.5 3 .04.87a2 2 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14H9v-1H2.826a1 1 0 0 1-.995-.91l-.637-7A1 1 0 0 1 2.19 4h11.62a1 1 0 0 1 .996 1.09L14.54 8h1.005l.256-2.819A2 2 0 0 0 13.81 3H9.828a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 6.172 1H2.5a2 2 0 0 0-2 2m5.672-1a1 1 0 0 1 .707.293L7.586 3H2.19q-.362.002-.683.12L1.5 2.98a1 1 0 0 1 1-.98z"/>
                <path d="M11 11.5a.5.5 0 0 1 .5-.5h4a.5.5 0 1 1 0 1h-4a.5.5 0 0 1-.5-.5"/>
              </svg>
              {assetsYears[i].year}
            </h3>
          </div>
          <YearAssets
            year={assetsYears[i].year}
          />
        </React.Fragment>  
      )
    } else {
      assetsYearsRows.push(
        <div
          key={assetsYears[i].year}  
          className="row mx-3 mt-3 p-2 pt-3 rounded year-hover"
          onClick={() => openYearFolder(i)}
        >
          <h3>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" className="bi bi-folder-plus me-3" viewBox="0 0 16 16">
              <path d="m.5 3 .04.87a2 2 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14H9v-1H2.826a1 1 0 0 1-.995-.91l-.637-7A1 1 0 0 1 2.19 4h11.62a1 1 0 0 1 .996 1.09L14.54 8h1.005l.256-2.819A2 2 0 0 0 13.81 3H9.828a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 6.172 1H2.5a2 2 0 0 0-2 2m5.672-1a1 1 0 0 1 .707.293L7.586 3H2.19q-.362.002-.683.12L1.5 2.98a1 1 0 0 1 1-.98z"/>
              <path d="M13.5 9a.5.5 0 0 1 .5.5V11h1.5a.5.5 0 1 1 0 1H14v1.5a.5.5 0 1 1-1 0V12h-1.5a.5.5 0 0 1 0-1H13V9.5a.5.5 0 0 1 .5-.5"/>
            </svg>
            {assetsYears[i].year}
          </h3>
        </div>

      )
    }  
  }

  return(
    <>
      <div className="row">
        <h3 className="m-3">Материалы</h3>
      </div>
      <div className="d-flex gap-2 m-3">
        <Link className="lk-button" to={`/asset_create`}>Добавить материал</Link>
        <Link className="lk-button ms-4" to={`/asset_mass_load`}>Массовая загрузка</Link>
      </div>
      {assetsYearsRows} 
    </>
  );
}

